import { TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTableBody = styled(TableBody)(({ theme }) => ({}));

export { PeekTableBody, PeekTableBody as default };
